import { useState } from "react";
import LazyLoad from "react-lazyload";
import { NavLink, Link } from "react-router-dom";
const Header = () => {
  const [menubar, setMenubar] = useState(false);

  return (
    <>
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="top-header">
                <ul className="phoneHide">
                  <li>&nbsp;</li>
                  <li>
                    <NavLink to="/about">
                      <span>
                        <i className="bi bi-book-half"></i>
                      </span>{" "}
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Primarywing">
                      <span>
                        <i className="bi bi-mortarboard-fill"></i>
                      </span>{" "}
                      Learning Approach
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/howtoapply">
                      <span>
                        <i className="bi bi-laptop-fill"></i>
                      </span>{" "}
                      Admissions
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/news">
                      <span>
                        <i className="bi bi-stickies-fill"></i>
                      </span>{" "}
                      News & Events
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contactUs">
                      <span>
                        <i className="bi bi-person-lines-fill"></i>
                      </span>{" "}
                      Contact Us
                    </NavLink>
                  </li>
                  <div className="logo">
                    <Link to="/">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/logo.jpg"
                        alt="Lotus Valley Gurgaon"
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <li>
                    <NavLink
                      to="https://picksindia.com/login/lotus-valley-international-school-gurugram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <i className="bi bi-person-vcard-fill"></i>
                      </span>{" "}
                      I-Card
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/mandatoryPublicDisclosure">
                      <span>
                        <i className="bi bi-file-earmark-ruled-fill"></i>
                      </span>{" "}
                      Mandatory Public Disclosure
                    </NavLink>
                  </li>
                  <li style={{ width: "100px" }}>
                    <NavLink to="/NEP2020">
                      <span>
                        <i className="bi bi-file-earmark-ruled-fill"></i>
                      </span>{" "}
                      LVISG Marches towards NEP 2020
                    </NavLink>
                  </li>
                  {/* <li><NavLink to="/wallOfFame"><span><i className="bi bi-mortarboard-fill"></i></span> Wall of Fame Section</NavLink></li> */}
                  <li>
                    <NavLink to="/vistas">
                      <span>
                        <i className="bi bi-mortarboard-fill"></i>
                      </span>{" "}
                      VISTAS
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="https://www.lviscampuscare.org/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <i className="bi bi-person-fill"></i>
                      </span>{" "}
                      Login
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/cyberSecurity" rel="noreferrer">
                      <span>
                        <i class="bi bi-database-fill-lock"></i>
                      </span>{" "}
                      Cyber Security
                    </NavLink>
                  </li>
                </ul>

                <ul className={menubar ? "menuPhone active" : "menuPhone"}>
                  <li>
                    <NavLink to="/about">
                      <span>
                        <i className="bi bi-book-half"></i>
                      </span>{" "}
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Primarywing">
                      <span>
                        <i className="bi bi-mortarboard-fill"></i>
                      </span>{" "}
                      Learning Approach
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/howtoapply">
                      <span>
                        <i className="bi bi-laptop-fill"></i>
                      </span>{" "}
                      Admissions
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/news">
                      <span>
                        <i className="bi bi-stickies-fill"></i>
                      </span>{" "}
                      News & Events
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contactUs">
                      <span>
                        <i className="bi bi-person-lines-fill"></i>
                      </span>{" "}
                      Contact Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="https://picksindia.com/login/lotus-valley-international-school-gurugram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <i className="bi bi-person-vcard-fill"></i>
                      </span>{" "}
                      I-Card
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/mandatoryPublicDisclosure">
                      <span>
                        <i className="bi bi-file-earmark-ruled-fill"></i>
                      </span>{" "}
                      Mandatory Public Disclosure
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/NEP2020">
                      <span>
                        <i className="bi bi-file-earmark-ruled-fill"></i>
                      </span>{" "}
                      LVISG Marches towards NEP 2020
                    </NavLink>
                  </li>
                  {/* <li><NavLink to="/wallOfFame"><span><i className="bi bi-mortarboard-fill"></i></span> Wall of Fame Section</NavLink></li> */}
                  <li>
                    <NavLink to="/vistas">
                      <span>
                        <i className="bi bi-mortarboard-fill"></i>
                      </span>{" "}
                      VISTAS
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="https://www.lviscampuscare.org/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>
                        <i className="bi bi-person-fill"></i>
                      </span>{" "}
                      Login
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/cyberSecurity" rel="noreferrer">
                      <span>
                        <i class="bi bi-database-fill-lock"></i>
                      </span>{" "}
                      Cyber Security
                    </NavLink>
                  </li>
                </ul>

                <div className="menuBar" onClick={() => setMenubar(!menubar)}>
                  <i className="bi bi-list"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="virtual-tour">
        <Link
          to="https://iviewd.com/lotus_valley_gurgaon/"
          target="_blank"
          rel="noreferrer"
        >
          <LazyLoad>
            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/virtual-tour.jpg" />
          </LazyLoad>
        </Link>
      </div>
    </>
  );
};

export default Header;
